import React, { useContext } from 'react';
import styled, { ThemeContext } from 'styled-components/native';
import { IStyleTheme, IThemePart } from '../../../../../theme';
import TaskInfoElement from '../task-info-element';

const Conatiner = styled.View`
  display: flex;
  flex-direction: column;
  padding: 10px 15px;
  align-items: flex-start;
`;

const Row = styled.View`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: space-between;
  justify-content: space-between;
`;

const TaskDetailLoading = () => {
  const themeContext: IThemePart = useContext(ThemeContext);
  return (
    <>
      <Conatiner>
        <Row>
          <TaskInfoElement title={'担当者'} style={{ flex: 1 }}></TaskInfoElement>
        </Row>
        <Row>
          <TaskInfoElement title={'優先度'} style={{ flex: 1 }}></TaskInfoElement>
        </Row>
        <Row>
          <TaskInfoElement title={'開始予定日'} style={{ flex: 1 }}></TaskInfoElement>
          <TaskInfoElement title={'〆切日'} style={{ flex: 1 }}></TaskInfoElement>
        </Row>
        <Row>
          <TaskInfoElement title={'作業時間'} style={{ flex: 1 }}></TaskInfoElement>
          <TaskInfoElement title={'見積時間'} style={{ flex: 1 }}></TaskInfoElement>
        </Row>
        {/* <Row>
          <TaskInfoElement title={'進捗率'} style={{ flex: 1 }}></TaskInfoElement>
          <TaskInfoElement
            title={`計画した${'\n'}見積時間`}
            style={{ flex: 1 }}></TaskInfoElement>
        </Row>
        <Row>
          <TaskInfoElement title={'アドバイス'} style={{ flex: 1 }}></TaskInfoElement>
        </Row> */}
        <Row>
          <TaskInfoElement title={'説明'} style={{ flex: 1 }}></TaskInfoElement>
        </Row>
      </Conatiner>
    </>
  );
};

export default TaskDetailLoading;
